import { withNamespaces } from "react-i18next";
import { toast } from "react-toastify";
import { useMutation } from "@tanstack/react-query";

import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Spinner,
} from "reactstrap";
import QuestionnaireDesignerService from 'src/modules/3rd-party-management/apis/admin/QuestionnaireDesignerService';

const WithdrawRequestsModal = ({
    t,
    onSuccess,
    itemToWithdraw,
    hideModal
}) => {
    const {
        mutate: mutateWithdraw,
        isLoading: withdrawInProcess
    } = useMutation({
        mutationFn: async () => {
            const service = QuestionnaireDesignerService.getInstance();
            return await service.withdrawQuestionnaireRequests(
                itemToWithdraw.id
            );
        },
        onSuccess: () => {
            onSuccess && onSuccess();

            toast(t("All uncompleted report requests for the questionnaire were withdrawn successfully."), {
                type: "success",
            });

            hideModal();
        },
        onError: () => {
            toast(t("Failed to withdraw uncompleted report requests for the questionnaire."), {
                type: "error"
            });
        }
    });

    return (
        <Modal size="md" isOpen={ itemToWithdraw }>
            <ModalHeader toggle={ hideModal }>
                {t('Confirm Withdrawal')}
            </ModalHeader>
                
            <ModalBody>
                <p>
                    {t('Are you sure you want to withdraw all uncompleted report requests for this questionnaire? This action cannot be undone.')}
                </p>
            </ModalBody>

            <ModalFooter>
                <Button 
                    color="danger" 
                    onClick={ hideModal }
                    disabled={withdrawInProcess}
                > 
                    { t('Cancel') }
                </Button>

                <Button 
                    type="button" 
                    color="primary"
                    onClick={mutateWithdraw}
                    disabled={withdrawInProcess}
                >
                    {
                        withdrawInProcess && (
                            <Spinner animation="border" variant="primary" size="sm"/>
                        )
                    }
                    { t('Withdraw All') }
                </Button>
            </ModalFooter>
        </Modal>
    )
};

export default withNamespaces()(WithdrawRequestsModal);